import { Package } from "lucide-react";
import { imgSrc } from "../lib/api";

const STATUS_CLS = {
  Beklemede: "bg-amber-100 text-amber-800 border-amber-300",
  "Onaylandı": "bg-blue-100 text-blue-800 border-blue-300",
  "Hazırlanıyor": "bg-indigo-100 text-indigo-800 border-indigo-300",
  "Teslim Edildi": "bg-emerald-100 text-emerald-800 border-emerald-300",
  "İptal": "bg-rose-100 text-rose-800 border-rose-300",
};

export const StatusBadge = ({ status, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center rounded-md border px-2 py-0.5 font-mono text-[11px] uppercase tracking-wider ${STATUS_CLS[status] || ""}`}>
    {status}
  </span>
);

export const ProductImage = ({ product, className = "" }) => {
  const src = imgSrc(product);
  return (
    <div className={`overflow-hidden bg-slate-100 flex items-center justify-center ${className}`}>
      {src ? <img src={src} alt={product.name} className="h-full w-full object-cover" loading="lazy" />
        : <Package className="h-1/3 w-1/3 text-slate-300" strokeWidth={1.5} />}
    </div>
  );
};

export const PageHeader = ({ title, kicker, children }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between fade-up">
    <div>
      {kicker && <p className="font-mono text-xs uppercase tracking-[0.2em] text-blue-600 mb-2">{kicker}</p>}
      <h1 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-950">{title}</h1>
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);
